import { telemetryLogin, telemetryLogout, setMetadata } from '@creditornot/browser-telemetry';
import type { User } from '@creditornot/wolt-auth';

export const customTelemetryLogin = (user: User) => {
  telemetryLogin(user.id);
  setMetadata({ is_wolt_employee: !!user?.roles.includes('employee') });
};

export const customTelemetryLogout = () => {
  telemetryLogout();
  setMetadata({});
};
